import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		section: {
			marginTop: '30px',
		},
		sectionTitle: {
			fontSize: '32px',
			lineHeight: '1.2em',
			fontWeight: 300,
			marginTop: '0px',
			marginBottom: '10px',
			[theme.breakpoints.down('sm')]: {
				fontSize: '20px',
			},
		},
		inlineEmphasizedText: {
			fontWeight: 700,
			display: 'inline',
		},
		experienceItem: {
			minHeight: '70px',
			width: '100%',
			border: '1px solid #ebebeb',
			borderRadius: '7px',
			padding: '30px 10px 20px 10px',
			margin: '20px 0px',
			position: 'relative',
			'-webkit-box-shadow': '0px 1px 3px 0px rgba(180, 180, 180, 0.1)',
			'-moz-box-shadow': '0px 1px 3px 0px rgba(180, 180, 180, 0.1)',
			boxShadow: '0px 1px 3px 0px rgba(180, 180, 180, 0.1)',
		},
		companyNameOuterContainer: {
			left: 10,
			border: '1px solid #ebebeb',
			// width: '100px',
			borderRadius: 32,
			height: 36,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			position: 'absolute',
			top: -18,
			backgroundColor: '#FFF',
			padding: 5,
			fontSize: '14px',
			color: '#424242',
		},
		companyNameInnerContainer: {
			display: 'flex',
			width: '100%',
			justifyContent: 'space-around',
			'& > span': {
				color: '#1B1A7C',
				cursor: 'pointer',
				fontWeight: 500,
				marginLeft: 4,
			},
		},
		timeAndPlaceOuterContainerCommon: {
			border: '1px solid #ebebeb',
			borderRadius: '32px',
			height: '36px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			backgroundColor: '#FFF',
			padding: '10px',
			fontSize: '14px',
		},
		timeAndPlaceOuterContainer: {
			top: '-18px',
			right: '10px',
			position: 'absolute',
		},
		timeAndPlaceOuterContainerMobile: {
			width: 'fit-content',
		},
		timeAndPlaceInnerContainer: {
			display: 'flex',
			width: '100%',
			justifyContent: 'space-around',
			fontSize: '14px',
			color: '#929292',
			height: '11px',
			lineHeight: '11px',
			'& span': {
				color: '#989898',
				fontSize: '14px',
				fontWeight: 400,
				height: '11px',
				lineHeight: '11px',
			},
		},
		locationInformation: {
			borderLeft: '2px solid #989898',
			padding: '0px 5px',
			marginLeft: '7px',
		},
		jobTitleCommon: {
			color: '#424242',
			fontSize: '18px',
			fontWeight: 500,
		},
		jobTitle: {
			marginTop: '0px',
			marginBottom: '0px',
		},
		jobTitleMobile: {
			marginTop: '15px',
			marginBottom: '0px',
		},
		jobDescription: {
			color: theme.palette.grey[600],
			fontSize: '14px',
			fontWeight: 300,
			marginTop: '8px',
		},
		editIconLabel: {
			paddingLeft: 6,
			paddingRight: 6,
		},
		editRootElement: {
			position: 'absolute',
			top: 0,
			right: 0,
			[theme.breakpoints.down('md')]: {
				top: 0,
				right: 5,
				[theme.breakpoints.only('xs')]: {
					width: 30,
					height: 30,
					'& svg': {
						fontSize: '1.2rem',
					},
				},
			},
		},
		saveEdit: {
			position: 'absolute',
			right: 0,
			top: 6,
			fontSize: 16,
			border: '1px solid #FC2652',
			padding: '0 8px',
			borderRadius: 12,
			color: '#FC2652',
			cursor: 'pointer',
		},
		saveSuccess: {
			position: 'absolute',
			right: 0,
			top: 6,
			fontSize: 13,
			color: '#FC2652',
		},
	})
